import React, { useState } from 'react';
import { Avatar, Box, Button, Checkbox, Container, createTheme, CssBaseline, FormControlLabel, Grid, Link, TextField, ThemeProvider, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import * as CryptoJS from "crypto-js";
import '../App.css';
import * as API from "../External/APIcalls";
import { useCookies } from 'react-cookie';
import InnospecIcon from "./InnospecLogo"
import { CognitoUserPool, CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import NewPasswordModal from './NewPasswordModal';

function Copyright(props: any) {
    //Simple Copyright text.
    
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {"© "}
        <Link color="inherit" href="https://innospec.com/">
          Innospec
        </Link>
        {" "}
        {new Date().getFullYear()}
        {" , All rights reserved."}
      </Typography>
    );
}

const getAuthKey = async (username: string, password: string) => {
    //Request an authKey from the backend
    const data = await API.authDB(username, password);
    console.log(data);
    return { auth: data.result.auth, name: data.result.name, id: data.result.id };
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

function SignIn() {
    const [cookies, setCookie] = useCookies(["authKey", "username", "userId", "logo64", "customerName", "userStatus"]);
    const [isErrorVisible, setIsErrorVisible] = useState(false);

    //Change password stuff
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [challengeSession, setChallengeSession] = useState<string | null>(null);
    const [email, setEmail] = useState('');

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        //This event fires when the "Sign In" button is clicked.

        event.preventDefault();
        const data = new FormData(event.currentTarget);

        //We get the username and password from the event object
        let email: any = data.get("email");
        let password: any = data.get("password");

        //hash the password via MD5 (NOTE: This should be changed to SHA256)
        //let passMD5: string = CryptoJS.MD5(password).toString();

        try {
            //Call the getAuthKey function and await the result.
            /*let authKey = await (await getAuthKey(username, passMD5)).auth;
            let name = await (await getAuthKey(username, passMD5)).name;
            let id = await (await getAuthKey(username, passMD5)).id;

            if (authKey === undefined || authKey === "" || authKey === null) {
                //If the authKey is invalid we notify the user of invalid credentials.
                setIsErrorVisible(true);
                return;
            } else {
                //If the authKey is valid we set it as a cookie and redirect back to the home page.
                setIsErrorVisible(false);

                let expires = new Date();
                expires.setHours(expires.getHours() + 3); //Set expiry time to 3 hours into the future.

                setCookie("authKey", authKey, { path: "/" , expires });
                setCookie("username", name, { path: "/" , expires });
                setCookie("userId", id, { path: "/" , expires });

                window.location.href = "/";
            }*/
            //console.log("We in!");
            //console.log(email, password);

            setEmail(email); // Store for use in modal

            const resp = await fetch("https://vmi2.innospecportal.com/api/authorize", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "email": email,
                    "password": password,
                    "region": "us"
                })
            });

            const result = await resp.json();

            if (resp.status === 409 && result.challenge === 'NEW_PASSWORD_REQUIRED') {
              // Cognito challenge — prompt for new password
              setChallengeSession(result.session);
              setShowPasswordModal(true);
            } else if (result.success) {
            	let expires = new Date();
                expires.setHours(expires.getHours() + 3); //Set expiry time to 3 hours into the future.

                if (result.userStatus !== "Super Admin") {
                    setCookie("authKey", result.key, { path: "/" , expires });
                    //setCookie("logo64", result.logo64, { path: "/" , expires });
                    localStorage.setItem("logo64", result.logo64);
                    setCookie("customerName", result.customerName, { path: "/" , expires });
                    setCookie("userStatus", result.userStatus, { path: "/" , expires });
                } else {
                    setCookie("authKey", result.key, { path: "/" , expires });
                    setCookie("userStatus", result.userStatus, { path: "/" , expires });
                    localStorage.setItem("logo64", "");
                    setCookie("customerName", "Super Admin", { path: "/" , expires });
		    
		    // TODO: Probably a good idea to wipe this after a while to not leak anything.
		    localStorage.setItem("customerList", JSON.stringify(result.customerList));
		    console.log(result.customerList);
		}
                
                window.location.href = "/";
                console.log('Logged in:', result);
	    } else {
              // ❌ Invalid login
              setIsErrorVisible(true);
              console.error('Login failed');
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleNewPasswordSubmit = async (newPassword: string) => {
      if (!challengeSession) return;

      const response = await fetch("https://vmi2.innospecportal.com/api/challengeresponse", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            "challenge": "NEW_PASSWORD_REQUIRED",
            "email": email,
            "new_password": newPassword,
            "session": challengeSession
        })
      });

      const result = await response.json();
      
      if (result.success) {
        setShowPasswordModal(false);
        setChallengeSession(null);
        // ✅ Proceed with login — store token or API key
        console.log('Challenge complete:', result);
        window.location.reload();
      } else {
        // ❌ handle error
        console.error('Failed to complete challenge');
      }
    };

    //Simple Sign-In form.
    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <InnospecIcon sx={{ mb: 1 }} />

                    <Typography component="h1" variant="h5">
                        Sign In to VMI
                    </Typography>

                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField 
                            margin="normal" 
                            required 
                            fullWidth 
                            id="email" 
                            label="Email" 
                            name="email" 
                            autoComplete="email" 
                            autoFocus
                        />
                        <TextField 
                            margin="normal" 
                            required 
                            fullWidth 
                            id="password" 
                            label="Password" 
                            name="password" 
                            type="password" 
                            autoComplete="current-password" 
                        />

                        <Typography 
                            id="invalid-password-text" 
                            component="h2" 
                            variant="subtitle1" 
                            color="error.main" 
                            visibility={isErrorVisible ? "visible" : "hidden"}
                        >
                            Invalid email or password.
                        </Typography>

                        <Button 
                            type="submit" 
                            fullWidth 
                            variant="contained" 
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Sign In
                        </Button>
                    </Box>

                    <NewPasswordModal
                      open={showPasswordModal}
                      onClose={() => setShowPasswordModal(false)}
                      onSubmit={handleNewPasswordSubmit}
                      email={email}
                    />
                </Box>
                
                <Copyright sx={{ mt: 8, mb: 4 }} />

            </Container>
        </ThemeProvider>
    );
}

export default SignIn;
